import { Activity } from '@microsoft/agents-activity'
import { ConnectionSettings, CopilotStudioClient } from '@microsoft/agents-copilotstudio-client'
import { getAgentToken } from './auth'
import { config } from './config'

const connectionSettings = new ConnectionSettings({
  directConnectUrl: config.directConnectUrl,
})

/**
 * Creates a Copilot Studio client bound to a freshly acquired user token.
 * A new client is created per turn so the token is never stale.
 */
export async function createAgentClient(): Promise<CopilotStudioClient> {
  const token = await getAgentToken()
  return new CopilotStudioClient(connectionSettings, token)
}

export function buildUserMessage(text: string): Activity {
  return Activity.fromObject({ type: 'message', text })
}

/** The conversation id is echoed back on the activities the agent sends. */
export function conversationIdOf(activity: Activity): string | undefined {
  return activity.conversation?.id
}

export type { Activity }
